import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "src", "posterUrl", "controls", "maxHeight"];
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SimpleVideoPlayer = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      className,
      src,
      posterUrl,
      controls = true,
      maxHeight
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("video", Object.assign({
      "data-test-id": "video-player",
      ref: ref,
      className: className,
      src: src,
      poster: posterUrl,
      controls: controls,
      controlsList: "nodownload",
      preload: "metadata",
      style: {
        maxHeight,
        width: '100%',
        verticalAlign: 'middle'
      }
    }, rest))
  );
});
export default SimpleVideoPlayer;